module.exports = __webpack_public_path__ + "static/favicon-af29628a3db308f0d0cd8e269c34d63d.png";